import log from 'salvo-lite/log'

class ScrollClass {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = Object.assign({
            targetElemSelector: '',
            scrollClass: 'fixed',
            maxWidth: 9999999999,
            minWidth: 0,
            headerHeight: document.querySelector('.site-header').offsetHeight
        }, JSON.parse(elem.getAttribute('data-scroll-class') || '{}'))
        this._distanceFromTop = window.pageYOffset + this._elem.getBoundingClientRect().top
        this._targetElem = document.querySelector(this._data.targetElemSelector)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        // this._updateDistanceFromTop()

        if (window.innerWidth <= this._data.maxWidth) {
            this._classLogic()
            window.addEventListener('scroll', () => this._classLogic())
        }
    }

    _updateDistanceFromTop () {
        // update distancefromtop when images have loaded
        document.querySelector('.product__images [data-preload]').addEventListener('preload-complete', () => {
            this._distanceFromTop = window.pageYOffset + this._elem.getBoundingClientRect().top
        })
    }

    _classLogic () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        if (scrollTop >= this._distanceFromTop) {
            !this._targetElem.classList.contains(this._data.scrollClass) && this._targetElem.classList.add(this._data.scrollClass)
        } else {
            this._targetElem.classList.contains(this._data.scrollClass) && this._targetElem.classList.remove(this._data.scrollClass)
        }
    }
}

export default ScrollClass



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ScrollClass.js